import * as actionTypes from 'constants/ActionTypes';

const cargoTypes = (state = [], action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_TYPES.REQUEST:
        return [
            ...state,
        ];
    case actionTypes.GET_CARGO_TYPES.SUCCESS:
        return [
            ...action.data,
        ];
    case actionTypes.GET_CARGO_TYPES.FAILURE:
        return [
            ...state
        ];
    default:
        return state;
    }
};

export default cargoTypes;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/types.js